import { render, staticRenderFns } from "./LogoZhihuIcon.vue?vue&type=template&id=4f0de9c9&"
import script from "./LogoZhihuIcon.vue?vue&type=script&lang=js&"
export * from "./LogoZhihuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports